import { createHttpRequest } from "../../../../api/utils/httpRequest"
import type { GoogleBusinessInfoResponse } from "./types"

export const fetchGoogleBusinessInfo = async (
    headers: Record<string, string>,
    locationId: string
): Promise<GoogleBusinessInfoResponse> => {
    const response = await createHttpRequest({
        method: "GET",
        path: `/google-business/info?locationId=${encodeURIComponent(locationId)}`,
        headers: headers,
    })

    return response as GoogleBusinessInfoResponse
}
